import React, { FC, SyntheticEvent, useContext } from 'react';
import { getLogoUrl, dateFormat } from '@bepro-travel/fe.utils';
import { useTranslation } from 'react-i18next';
import { Flight } from '../../ts/interfaces/OphirBook';
import { blobUrl, imgBg } from '../../constants';

interface FlightDetailsProps {
  flights: Flight[];
}

const FlightDetails: FC<FlightDetailsProps> = ({ flights }) => {
  const [t] = useTranslation() as unknown as [(key: string) => string];
  const onImageLoadError = ({ currentTarget }: SyntheticEvent<HTMLImageElement, Event>) => {
    currentTarget.onerror = null;
    currentTarget.src = imgBg;
  };
  return (
    <div className="oph-table-sm-wr default-shadow mt-30">
      <div className="oph-table-sm-title">{t('op.flight_details')}</div>
      <table className="oph-table-sm">
        <tbody>
          {flights.map(({ legs }, index) => (
            <tr key={index}>
              <td>
                <div className="oph-table-sm-logo">
                  <img
                    src={getLogoUrl(blobUrl, legs?.[0].airline.code)}
                    alt="logo"
                    onError={onImageLoadError}
                  />
                  <span className="name">{legs?.[0].airline.desc}</span>
                </div>
              </td>
              <td>{legs?.[0].departureLocation.code}</td>
              <td>
                <div>{dateFormat(legs?.[0].depDate, 'dd.MM')}</div>
                <div>{legs?.[0].depHour}</div>
              </td>
              <td>{legs?.[0].arrivalLocation.code}</td>
              <td>
                <div>{dateFormat(legs?.[0].arrDate, 'dd.MM')}</div>
                <div>{legs?.[0].arrHour}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FlightDetails;
